import { baseRTKApi } from 'shared/api/baseApi';

/**
 * Этот файл участвует в формировании типов на сервере
 * Поэтому импорты тут не должны вести на вьюхи, только на редьюсеры в моделях
 * иначе сервак может развалиться
 * */
import { analyticsSlice } from 'entities/analytics/model/analytics.slice';
import { appConfigSlice } from 'entities/appConfig/model/appConfig.slice';
import { groupsSlice } from 'entities/groups/model/groups.slice';
import { locationSlice } from 'entities/locations/model/location.slice';
import { metadataSlice } from 'entities/metadata/model/metadata.slice';
import { mfoFormSlice } from 'entities/mfo/model/mfoForm.slice';
import { offersSlice } from 'entities/offers/model/offers.slice';
import { offersFiltersSlice } from 'entities/offersFilters/model/offersFilters.slice';
import { persistedStoreSlice } from 'entities/persistedStore/model/persistedStore.model';
import { pledgeAutoFormSlice } from 'entities/pledgeAutoForm/model/pledgeAutoForm.slice';
import { pledgeEstateFormSlice } from 'entities/pledgeEstateForm/model/pledgeEstateForm.slice';
import { preApprovalsSlice } from 'entities/preApprovals';
import { productSlice } from 'entities/product';
import { offerProcessingSlice } from 'entities/scenario/model/offerProcessing.slice';
import { scenarioSlice } from 'entities/scenario/model/scenario.slice';
import { creditTimerSlice } from 'entities/scenario/model/timer/creditTimer.slice';
import { userScoreSlice } from 'entities/scoring/model/userScore.slice';
import { siteSettingsSlice } from 'entities/siteSettings/model/siteSettings.slice';
import { userSlice } from 'entities/user/model/user.slice';
import { utmMarksSlice } from 'entities/utmMarks/model/utmMarks.slice';
import { vitrinsSlice } from 'entities/vitrins/model/vitrins.slice';
import { vitrinsFiltersSlice } from 'entities/vitrinsFilters/model/vitrinsFilters.slice';
import { whiteLabelSlice } from 'entities/whiteLabels/model/whiteLabels.model';
import { whiteLabelUserDataSlice } from 'entities/whiteLabelUserData/model/whiteLabelUserData.model';
import { abExperimentsSlice } from 'src/client/entities/abExperiments/model/abExperiments.slice';
import { creditFormSlice } from 'src/client/entities/creditForm/model/creditForm.slice';

export const reducers = {
  siteSettings: siteSettingsSlice.reducer,
  metadata: metadataSlice.reducer,
  user: userSlice.reducer,
  locations: locationSlice.reducer,
  userScore: userScoreSlice.reducer,
  groups: groupsSlice.reducer,
  offers: offersSlice.reducer,
  creditForm: creditFormSlice.reducer,
  pledgeAutoForm: pledgeAutoFormSlice.reducer,
  pledgeEstateForm: pledgeEstateFormSlice.reducer,
  mfoForm: mfoFormSlice.reducer,
  whiteLabel: whiteLabelSlice.reducer,
  persistedStore: persistedStoreSlice.reducer,
  whiteLabelUserData: whiteLabelUserDataSlice.reducer,
  offersFilters: offersFiltersSlice.reducer,
  preApprovals: preApprovalsSlice.reducer,
  abExperiments: abExperimentsSlice.reducer,
  utmMarks: utmMarksSlice.reducer,
  vitrinsOffers: vitrinsSlice.reducer,
  analytics: analyticsSlice.reducer,
  appConfig: appConfigSlice.reducer,
  product: productSlice.reducer,
  [vitrinsFiltersSlice.name]: vitrinsFiltersSlice.reducer,
  [scenarioSlice.name]: scenarioSlice.reducer,
  [creditTimerSlice.name]: creditTimerSlice.reducer,
  [offerProcessingSlice.name]: offerProcessingSlice.reducer,

  [baseRTKApi.reducerPath]: baseRTKApi.reducer,
};
